// extracted by mini-css-extract-plugin
export const tileHeader = "our-beliefs-module--tileHeader--3C2Kk";
export const tile = "our-beliefs-module--tile--1HsRi";
export const tile__content = "our-beliefs-module--tile__content--1syaR";
export const tile__front = "our-beliefs-module--tile__front--3AIlx";
export const tile__back = "our-beliefs-module--tile__back--2aayv";
export const tile__belief = "our-beliefs-module--tile__belief--2KzGj";
export const tile__explanation = "our-beliefs-module--tile__explanation--3Pq25";